import { Action, createReducer, on } from '@ngrx/store';
import * as NgrxWidgetActions from './actions/widget.actions';
import {
  StoreGroup,
  StoreWidget,
  StoreWidgetState,
  TemplateGroup,
  TemplatePayload,
  UiWidget,
  ViewMode,
  WidgetState
} from '@pt/pt-models';
import { GetChapterResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import { WidgetReducerUtils } from './widget-reducer-utils';
import { UpsertWidgetsRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpsertWidgetsRequest';

export const WIDGET_FEATURE_KEY = 'pt-widget';


export const initialState: WidgetState = {
  docInfo: null,
  lockEnabled: false,
  documentPermission: null,
  requireReloadResult: false,
  activeChapter: null,
  chapters: { chapters: [] },
  chapter: null,
  currentLanguage: null,
  widgets: [],
  groups: [],
  notifier: [],
  editItemActive: null,
  documentEditorNotifications: [],
  widgetNotifications: [],
  viewMode: ViewMode.LIST,
  warnings: []
};

export function widgetReducer(state: WidgetState | undefined, action: Action) {

  const WidgetReducer = createReducer(
      initialState,


      on(NgrxWidgetActions.debug, (state, action) => ({
        ...action.state
      })),

      on(NgrxWidgetActions.reloadWarningsSuccess, (state, action) => ({
        ...state,
        warnings: action.warnings
      })),

      on(NgrxWidgetActions.cleanAll, (state) => ({
        ...state,
        widgets: [],
        groups: [],
        notifier: [],
        editItemActive: null,
        documentEditorNotifications: []
      })),

      on(NgrxWidgetActions.loadChaptersSuccess, (state, action) => ({
        ...state,
        chapters: action.listTemplateChapter || { chapters: [] }
      })),

      on(NgrxWidgetActions.initializeChapterSuccess, (state, action) => {
        const chapterResponse: GetChapterResponse = action.chapter;
        if (chapterResponse === null) {
          return {
            ...state,
            widgets: [],
            groups: [],
            notifier: [],
            editItemActive: null
          };
        } else {
          const payload = chapterResponse?.payload as TemplatePayload;
          const groups = payload?.groups;
          const storeWidgets: StoreWidget[] = [];
          const storeGroups: StoreGroup[] = [];
          groups?.forEach((group: TemplateGroup) => {
            if (group.enabled) {
              storeGroups.push({
                id: group?.id,
                name: group?.name,
                loading: true,
                disabled: true,
                widgets: group?.widgets?.length
              } as StoreGroup);

              JSON.parse(JSON.stringify(group.widgets)).sort((a: UiWidget, b: UiWidget) => {
                return a.order > b.order ? 1 : -1;
              }).forEach((widget: UiWidget) => {
                // if (widget.enabled) {
                storeWidgets.push({
                  internalId: widget.internalId,
                  label: widget.label,
                  isValid: false,
                  isActivedEditMode: false,
                  version: widget.version,
                  state: StoreWidgetState.REGISTERED,
                  groupName: group.name,
                  groupId: group.id,
                  enabled: widget.enabled,
                  opt: widget.opt
                } as StoreWidget);
                // }
              });
            }
          });
          return {
            ...state,
            chapter: chapterResponse,
            groups: storeGroups,
            widgets: storeWidgets,
            editItemActive: null,
            requireReloadResult: false
          };
        }
      }),

      on(NgrxWidgetActions.saveDocInfo, (state, action) => {
        return {
          ...initialState,
          documentPermission: state.documentPermission,
          warnings: state.warnings,
          docInfo: action.docInfo
        };

      }),

      on(NgrxWidgetActions.loadDocumentPermissionSuccess, (state, action) => {
        return {
          ...state,
          documentPermission: action.operations
        };
      }),


      on(NgrxWidgetActions.reloadEditorDetails, (state) => ({
        ...state,
        editItemActive: null
      })),

      on(NgrxWidgetActions.reloadEditorDetailsSuccess, (state, action) => ({
        ...state,
        docInfo: {
          ...state.docInfo,
          updatedAt: action.details.updatedAt,
          userCheck: action.details.userCheck,
          name: action.details.name,
          status: action.details.status
        }
      })),


      on(NgrxWidgetActions.setViewMode, (state, action) => ({
        ...state,
        viewMode: action.viewMode
      })),

      on(NgrxWidgetActions.setEditorEditItemState, (state, action) => ({
        ...state,
        editItemActive: action.item
      })),

      on(NgrxWidgetActions.resetEditorEditItemState, (state) => ({
        ...state,
        editItemActive: null
      })),

      /**
       * Check Validity Document Failed
       */


      on(NgrxWidgetActions.setWidgetState, (state, action) => ({
        ...state,
        widgets: WidgetReducerUtils.setWidgetState(state?.widgets, action.widgetStatus)
      })),


      on(NgrxWidgetActions.upsertWidgetEnabled, (state, action: {request: UpsertWidgetsRequest}) => ({
        ...state,
        widgets: state?.widgets.map((storeWidget: StoreWidget) => {
          const upsertedWidget = action.request.widgets.find((w) => w.internalId === storeWidget.internalId);
          if (upsertedWidget) {
            return {
              ...storeWidget,
              enabled: upsertedWidget.enabled
            } as StoreWidget;
          } else {
            return storeWidget;
          }
        })
      })),

      on(NgrxWidgetActions.saveWidgetValidation, (state, action) => ({
        ...state,
        widgets: state?.widgets.map((storeWidget: StoreWidget) => {
          if (action.internalId === storeWidget.internalId) {
            return {
              ...storeWidget,
              isValid: action.valid
            } as StoreWidget;
          } else {
            return storeWidget;
          }
        })
      })),

      on(NgrxWidgetActions.notifyError, (state, action) => ({
        ...state,
        notifier: [...state.notifier.filter(n => n.id !== action.id), action]
      })),
      on(NgrxWidgetActions.reloadWidgetAfterSave, (state) => {
        return {
          ...state,
          requireReloadResult: true
        };
      }),
      on(NgrxWidgetActions.reloadedResult, (state) => {
        return {
          ...state,
          requireReloadResult: false
        };
      }),


      on(NgrxWidgetActions.execTriggerWidget, (state, action) => ({
        ...state,
        widgets: state?.widgets.map((storeWidget: StoreWidget) => {
          if (action.widget.internalId === storeWidget.internalId) {
            return {
              ...storeWidget,
              state: StoreWidgetState.TRIGGER_RUNNING
            } as StoreWidget;
          } else {
            return storeWidget;
          }
        })
      })),
      on(NgrxWidgetActions.loadChapter, (state, action) => {
        return {
          ...state,
          widgets: [],
          activeChapter: action.chapter
        };
      }),

      on(NgrxWidgetActions.emitDocumentEditorNotification, (state, action) => ({
        ...state,
        documentEditorNotifications: [...state.documentEditorNotifications, action.data]
      })),

      on(NgrxWidgetActions.clearDocumentEditorNotifications, (state) => ({
        ...state,
        documentEditorNotifications: []
      })),


      on(NgrxWidgetActions.emitWidgetNotification, (state, action) => ({
        ...state,
        widgetNotifications: [...state.widgetNotifications, action.notification]
      })),

      on(NgrxWidgetActions.setChapterStatusSuccess, (state, action) => ({
        ...state,
        chapters: {
          chapters: state.chapters.chapters.map(c => {
            return {
              ...c,
              lastUpdatedAt: c.id === action.chapterId ? Date.now() : c.lastUpdatedAt,
              currentStatus: c.id === action.chapterId ? action.request.status : c.currentStatus,
              completed: c.id === action.chapterId ? action.request.completed : c.completed
            };
          })
        },
        activeChapter: {
          ...state.activeChapter,
          lastUpdatedAt: Date.now(),
          currentStatus: action.request.status,
          completed: state.activeChapter.id === action.chapterId ? action.request.completed : state.activeChapter.completed
        }
      })),

      on(NgrxWidgetActions.clearWidgetNotifications, (state) => ({
        ...state,
        widgetNotifications: []
      })),

      on(NgrxWidgetActions.removeEditWidgetId, (state) => ({
          ...state,
          widgets: state.widgets
        })
      ),
      on(NgrxWidgetActions.setLanguage, (state, action: { language: string }) => ({
          ...state,
          currentLanguage: action.language
        })
      )
    )
  ;

  return WidgetReducer(state, action);
}
